import React from 'react';
import { useTranslation } from '@/contexts/LanguageContext';
import { cn } from '@/lib/utils';
import { LayoutGrid, Type, Image, Palette, SlidersHorizontal, Sparkles } from 'lucide-react';

export type MobileToolbarPanel = 'slides' | 'text' | 'image' | 'style' | 'config' | 'ai';

interface ToolbarItem {
  id: MobileToolbarPanel;
  icon: React.ElementType;
  labelKey: string;
  dataTour?: string;
}

const toolbarItems: ToolbarItem[] = [
  { id: 'slides', icon: LayoutGrid, labelKey: 'mobile.toolbar.slides', dataTour: 'mobile-tab-slides' },
  { id: 'text', icon: Type, labelKey: 'mobile.toolbar.text', dataTour: 'mobile-tab-edit' },
  { id: 'image', icon: Image, labelKey: 'mobile.toolbar.image', dataTour: 'mobile-tab-media' },
  { id: 'style', icon: Palette, labelKey: 'mobile.toolbar.style' },
  { id: 'config', icon: SlidersHorizontal, labelKey: 'mobile.toolbar.config' },
  { id: 'ai', icon: Sparkles, labelKey: 'mobile.toolbar.ai' },
];

interface MobileToolbarProps {
  activePanel: MobileToolbarPanel | null;
  onPanelChange: (panel: MobileToolbarPanel | null) => void;
}

const MobileToolbar: React.FC<MobileToolbarProps> = ({ activePanel, onPanelChange }) => {
  const { t } = useTranslation();

  return (
    <div className="h-14 mobile-safe-bottom bg-card border-t border-border flex-shrink-0">
      <div className="h-full flex items-center justify-around px-1">
        {toolbarItems.map((item) => {
          const Icon = item.icon;
          const isActive = activePanel === item.id;
          return (
            <button
              key={item.id}
              data-tour={item.dataTour}
              onClick={() => onPanelChange(isActive ? null : item.id)}
              className={cn(
                "flex flex-col items-center gap-0.5 py-1 px-2 rounded-lg text-xs transition-colors whitespace-nowrap",
                isActive ? "text-primary" : "text-muted-foreground"
              )}
            >
              <Icon className="h-5 w-5" />
              <span>{t(item.labelKey)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileToolbar;
export { toolbarItems };
